
// src/connects/main-page.js

import { pushRoute, replaceRoute, directRoute } from '../actions/route'
import { connect } from 'react-redux'
import { stripArray } from '../helpers/store'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import actions from '../actions'
import config from '../config'
import socketRsync, { provideRsync } from '../helpers/socket-rsync'
import { translate } from 'react-i18next'
import { setId } from '../helpers/analytics'
import LoginHistory from '../actions/login-history'
import GroupIdStore from '../actions/group-id-store'
import AnnouncesUnread from '../actions/announce-unread-flag'
import windowFocus from '../helpers/window-focus'
import { getArray } from '../helpers/store'
import map from 'lodash/map'
import { emitAlertMessage } from '../actions/alert-message'

export const mapStateToProps = (state)=> {
  return {
    organizations: stripArray(state.organizations.items),
    groups: stripArray(state.groups.items),
    isFetchingGroup: state.groups.isFetchingGroup,
    user: state.user.current,
    login: state.sessions.login,
    isFetching: state.organizations.isFetching || state.groups.isFetching || state.user.isFetching,
    isFetchFailed: state.organizations.isFetchFailed || state.groups.isFetchFailed || state.user.isFetchFailed,
    isPhone: state.media.isPhone,
    active: state.sidebar.open,
    pinned: (state.media.isPhone ? false : state.sidebar.docked),
    routes: state.routes,
    access_token: state.sessions.access_token,
    announceDate: state.announce.latest,
    socketNotification: state.socket.items['notification'],
    socketChat: state.socket.items['chat'],
    userSettings: state.userSettings,
    rightSidePage: state.rightSidePage,
    likeConfig: state.likes.likeConfig,
    notificationSettings: state.user.notificationSettings,
    unreadChatCount: state.chatRooms.unreadCount,
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    usersAdminUrl: `${config.baseUrl}v3/session/redirect?login=true&redirect_to=/v3/users&access_token=${stateProps.access_token}`,
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    willMount: (props)=> {
      dispatch(actions.closeAnnounce())
      if (!props.login) {
        var params = props.location && props.location.query || {}
        if (props.location && props.location.pathname != '/' && props.location.pathname != '/login' )
          params.redirect = props.location.pathname
        replaceRoute('login', params)
      }
      else {
        dispatch(actions.fetchCurrentUser())
        dispatch(actions.fetchDivisions())
        dispatch(actions.fetchGroups())
        dispatch(actions.fetchOrganizations())
        dispatch(actions.fetchBuildNo())
        dispatch(actions.fetchLikeConfig())
        dispatch(actions.fetchBlockDiaries())
        dispatch(actions.fetchBlockUsers())
        dispatch(actions.fetchReviewSetting())
        dispatch(actions.fetchShowTimestampSetting())
        dispatch(actions.fetchNotificationSettings())
        dispatch(actions.fetchChatRoomUnreadCount('main-page'))
      }
      dispatch(actions.fetchProductTourState())
      if (props.params && props.params.division_id)
        dispatch(actions.setCurrentDivisionId(props.params.division_id))
      else if (props.params)
        dispatch(actions.setCurrentDivisionId(null))
    },

    willUpdate: (props, nextProps)=> {
      if (nextProps.user && nextProps.groups && (
          nextProps.location && nextProps.location.pathname == '/' ||
					!(nextProps.routes instanceof Array) && nextProps.routes && (!nextProps.routes.name || nextProps.routes.name == 'main') || // スマホアプリの場合でかつ起動直後にのみ発火
          nextProps.params && nextProps.params.group_id && !getArray('group_id', nextProps.groups, nextProps.params.group_id))) {
        dispatch(actions.closeSidebar())
        if (directRoute && nextProps.location && nextProps.location.query && nextProps.location.query.redirect) {
          directRoute(
            nextProps.location.query.redirect + '?' +
            map(nextProps.location.query, (value, key)=> key != 'redirect' ? `${key}=${encodeURIComponent(value)}` : '').join('&')
          )
        }
        else if (nextProps.groups.length == 1) {
          replaceRoute('group_timeline', { group_id: nextProps.groups[0].group_id })
        }
        else {
          GroupIdStore.get((group_id)=> {
            if (group_id && getArray('group_id', nextProps.groups, group_id)) {
              replaceRoute('group_timeline', { group_id })
            }
            else {
              replaceRoute('home_group')
            }
          })
        }
      }

			if (props.groups && nextProps.groups && nextProps.groups.length > props.groups.length && nextProps.active) {
				// this.props.groups よりも nextProps.groups の方が要素が増えている = 新規作成されたグループ
      	// groupsの差分を計算し、新規作成したグループに遷移させる
				const thisIds = props.groups.map((group)=> group.group_id)
				const nextIds = nextProps.groups.map((group)=> group.group_id)
      	const group_id = nextIds.filter((id)=> thisIds.indexOf(id) == -1)[0]
       	pushRoute('group_timeline', { group_id })
			}

			// グループが削除されて0個になった場合、Web版の画面をHomeに切り替える
			if (nextProps.location && nextProps.location.pathname == '/' && !nextProps.isFetching && !nextProps.groups) {
	      replaceRoute('home_group')
    		dispatch(actions.openSidebar())
		  }

      /* gambaからのお知らせを最後にみた時刻(announce_last_seen_at)がnullか最新のお知らせ時刻(announceDate)よりも小さい場合はdispatch(actions.openAnnounce())が発火する*/
      if (!props.announceDate && nextProps.announceDate && nextProps.user && (
        !nextProps.user.announce_last_seen_at || nextProps.user.announce_last_seen_at < nextProps.announceDate)) {
        dispatch(actions.openAnnounce())
      }

      if (props.login && !nextProps.login) {
        pushRoute('login')
			}

      if (!props.user && nextProps.user) {
        LoginHistory.set(nextProps.user)
        setId(nextProps.user.user_id, nextProps.user.account && nextProps.user.account.account_id)
        props.initializeSocket(nextProps.user)
      }
      if (props.params && props.params.division_id)
        dispatch(actions.setCurrentDivisionId(props.params.division_id))
      else if (props.params)
        dispatch(actions.setCurrentDivisionId(null))
    },

    willUnmount: (props)=> {
      setId(undefined, undefined)
      dispatch(actions.clearDiaries())
      dispatch(actions.clearNotifications())
      dispatch(actions.clearAnnounce())
      dispatch(actions.clearChatRooms())
      dispatch(actions.clearChatMessages())
      dispatch(actions.clearChatRoomUnreadCount())
      dispatch(actions.openSidebar())
      props.destroySocket()
    },

    onOverlayClick: ()=> {
      dispatch(actions.closeSidebar())
    },

    onOpen: ()=> {
      dispatch(actions.openSidebar())
    },

    closeRightSidePage: ()=> dispatch(actions.closeRightSidePage()),
    closeSidebar: ()=> dispatch(actions.closeSidebar()),

    requestSync: (props)=> {
      dispatch(actions.fetchCurrentUser())
      dispatch(actions.fetchAnnounce())
      dispatch(actions.fetchBuildNo())
      dispatch(actions.fetchDivisions())
      dispatch(actions.fetchGroups())

      if (props.params && props.params.group_id) {
        dispatch(actions.fetchNotificationsUnreadCount(props.params.group_id))
        dispatch(actions.fetchGroupUnreadCount(props.params.group_id))
      }

      if (props.params && props.params.division_id) {
        dispatch(actions.fetchHomeNotificationsUnreadCount(props.params.division_id))
      } else {
        dispatch(actions.fetchHomeNotificationsUnreadCount())
      }
    },

    receiveSocket: (message, message_type, props)=> {
      switch (message_type) {
      case 'diary':
      case 'diary_delete':
        dispatch(actions.loadGroupUnreadCount(message.group_id, message.unreads))
        break
      case 'chat':
        if (
            message.chat &&
            message.chat.user &&
            message.chat.user.user_id &&
            props.user &&
            props.user.user_id &&
            (props.user.user_id != message.chat.user.user_id) &&
            props.rightSidePage &&
            (props.rightSidePage.name != "chat_messages")
          ) {
          if (props.notificationSettings && props.notificationSettings.others && (props.notificationSettings.others.notify_on_alert_display_to_chat == 'all' || props.notificationSettings.others.notify_on_alert_display_to_chat == 'mail')){
            // show toast for new message
            if (props.notificationSettings.others.notify_on_alert_display_to_chat == 'all' || props.notificationSettings.others.notify_on_alert_display_to_chat == 'push')
              // it means to show the content of the message
              dispatch(emitAlertMessage(`${message.chat.user.name ? message.chat.user.name : '不明なユーザー'} : ${message.chat.message_text ? message.chat.message_text : ''}`, 'messageAlert'))
            else { 
              // it means none or mail(view message only)
              dispatch(emitAlertMessage({ message: 'label:新着メッセージがあります', name: message.chat.user.name ? message.chat.user.name : '不明なユーザー' }, 'messageAlert'))
            }
          }
        }
        
        dispatch(actions.loadChatRoomUnreadCount(message.unread_count))
        break
      case 'group':
        dispatch(actions.loadGroup(message.group))
        break
      case 'group_delete':
        dispatch(actions.loadGroup(message.group, { deleted: true }))
        break
      case 'division':
        dispatch(actions.reloadDivision(message.division))
        break
      case 'division_delete':
        dispatch(actions.deleteDivisionCompleted(message))
        break
      }
    },

    onRegister: (token, type)=> {
      dispatch(actions.subscribeDeviceToken(token, type))
    },

    onNotification: (notification)=> {
      /*
      notification = {
        foreground: false, // BOOLEAN: If the notification was received in foreground or not
        userInteraction: false, // BOOLEAN: If the notification was opened by the user from the notification area or not
        message: 'My Notification Message', // STRING: The notification message
        data: {}, // OBJECT: The push data
      } */

      const url = notification.url || notification.data && notification.data.body && notification.data.body.url
      if (notification.foreground || !url)
        return

      const paths = url.replace(/^.+groups\//, '').split('/')
      var kpi_id, diary_id, chat_room_id, match
      var group_id = parseInt(paths[0])
      if (paths.length == 2 && paths[1] == 'timeline') {
        pushRoute('group_timeline', { group_id })
      }
      else if (paths.length == 4 && paths[2] == 'kpi_chart') {
        kpi_id = parseInt(paths[3])
        dispatch(actions.openRightSidePage('kpi_chart', { group_id, kpi_id }))
      }
      else if (paths.length == 3 && (match = paths[2].match(/^pickup\?diary_ids=([0-9]+)$/))) {
        diary_id = parseInt(match[1])
        dispatch(actions.openRightSidePage('pickup_diaries', { diary_ids: [diary_id] }))
      }
      else if (paths.length == 3 && paths[1] == 'messages') {
        chat_room_id = parseInt(paths[2])
        dispatch(actions.openRightSidePage('chat_messages', { chat_room_id, from: 'notification' }))
      }
      else if (paths.length == 2 && paths[1] == 'announces') {
        dispatch(actions.openRightSidePage('notifications', { group_id: 'home', tabIndex: 1 }))
      }
    },

    onWebNotification: (type, notification)=> {
      if (type == 'notification') {
        switch(notification.category) {
        case 'group_profile_updated':
        case 'user_profile_updated':
          return dispatch(actions.openRightSidePage('group_members', { group_id: notification.group_id }))
        case 'kpi_updated':
          return dispatch(actions.openRightSidePage('kpi_chart', { kpi_id: notification.kpi_id, group_id: notification.group_id }))
        case 'diary_reported':
        case 'kpi_reported':
        case 'memo_reported':
        case 'diary_replied':
        default:
          if (notification.diary_id)
            dispatch(actions.openRightSidePage('pickup_diaries', { diary_ids: [notification.diary_id] }))
          return
        }
      }
      if (type == 'chat')
        return dispatch(actions.openRightSidePage('chat_messages', { chat_room_id: notification.chat_room_id }))
    },

    onWindowFocus: (props)=> props.refreshSocket(),
    openUserSettingsPage: ()=> {
      dispatch(actions.closeSidebar())
      dispatch(actions.openUserSettingsPage())
    },
    
    logout: ()=> dispatch(actions.logout(false))
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  provideRsync,
  socketRsync('diary', 'diary_delete', 'chat', 'group', 'group_delete', 'division', 'division_delete'),
  translate(),
  lifecycle,
  windowFocus,
)



// WEBPACK FOOTER //
// ./src/connects/main-page.js